export default "__VITE_ASSET__BkcZTpL8__"